/* En-tête collant + fermeture du menu mobile.
   Restauré au lot 112 (reprise C) : sections/mobile-header-fix.liquid a été
   supprimé au commit b2f2dd3 en migrant son CSS dans sbc-base.css, sans
   porter ces deux scripts. Logique reprise à l'identique depuis
   `git show 1b6ab3f:sections/mobile-header-fix.liquid` — mêmes seuils, mêmes
   classes, mêmes cibles. */
(() => {
  const header = document.querySelector('[data-header]');
  if (!header || header.dataset.sbcStickyEvolution === 'true') return;

  header.dataset.sbcStickyEvolution = 'true';
  header.dataset.scrollRevealInit = 'true';
  header.dataset.mobileAlwaysVisible = 'true';
  header.classList.remove('is-scroll-detached','is-scroll-hidden','sbc-mobile-fixed');

  let spacer = header.nextElementSibling;
  if (!spacer || !spacer.classList.contains('sbc-fixed-header-spacer')) {
    spacer = document.createElement('div');
    spacer.className = 'sbc-fixed-header-spacer';
    spacer.setAttribute('aria-hidden','true');
    header.insertAdjacentElement('afterend', spacer);
  }

  let ticking = false;
  let isFixed = false;
  let isCompact = false;
  const bar = document.querySelector('.announcement');
  let announcementSpacer = null;
  if (bar) {
    announcementSpacer = document.createElement('div');
    announcementSpacer.className = 'sbc-announcement-spacer';
    announcementSpacer.setAttribute('aria-hidden', 'true');
    bar.insertAdjacentElement('afterend', announcementSpacer);
  }
  let lastY = Math.max(window.scrollY || 0, 0);
  let direction = 0;
  let distance = 0;
  let announcementRevealed = false;

  let annonceH = 0;
  const mesurer = () => {
    annonceH = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    if (isFixed) {
      spacer.style.height = Math.round(header.getBoundingClientRect().height) + 'px';
      if (announcementSpacer) announcementSpacer.style.height = annonceH + 'px';
    }
  };

  const MARGE_COMPACT = 48;

  const setFixed = (veut) => {
    if (veut === isFixed) return;
    const hauteurLiberee = veut ? Math.round(header.getBoundingClientRect().height) : 0;
    isFixed = veut;
    header.classList.toggle('sbc-fixed-header', veut);
    spacer.classList.toggle('is-active', veut);
    spacer.style.height = veut ? hauteurLiberee + 'px' : '0px';
    if (bar) {
      announcementSpacer.style.height = veut ? annonceH + 'px' : '0px';
      bar.classList.toggle('sbc-announcement--fixed', veut);
    }
    document.documentElement.classList.toggle('sbc-page-scrolled', veut);
  };

  const setCompact = (veut) => {
    if (veut === isCompact) return;
    isCompact = veut;
    header.classList.toggle('sbc-header-compact', veut);
  };

  const update = () => {
    ticking = false;
    const y = Math.max(window.scrollY || window.pageYOffset || 0, 0);
    const fixe = isFixed ? y > 0 : y >= annonceH;
    setFixed(annonceH === 0 ? y > 0 : fixe);
    setCompact(isFixed && y > annonceH + MARGE_COMPACT);
    const delta = y - lastY;
    if (delta !== 0) {
      const nextDirection = Math.sign(delta);
      if (nextDirection !== direction) {
        direction = nextDirection;
        distance = 0;
      }
      distance += Math.abs(delta);
      if (distance >= 8) announcementRevealed = direction < 0;
    }
    if (!isFixed) announcementRevealed = false;
    if (bar) {
      const revealed = isFixed && (announcementRevealed || Boolean(bar.querySelector(':focus-visible')));
      bar.classList.toggle('is-revealed', revealed);
      bar.inert = isFixed && !revealed;
      bar.setAttribute('aria-hidden', String(isFixed && !revealed));
      header.style.setProperty('--sbc-announcement-offset', revealed ? annonceH + 'px' : '0px');
    }
    lastY = y;
    header.classList.remove('is-scroll-detached','is-scroll-hidden','sbc-mobile-fixed');
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  const onResize = () => { mesurer(); requestUpdate(); };

  window.addEventListener('scroll', requestUpdate, {passive:true});
  window.addEventListener('touchmove', requestUpdate, {passive:true});
  window.addEventListener('resize', onResize, {passive:true});
  window.addEventListener('orientationchange', onResize, {passive:true});
  window.addEventListener('pageshow', onResize);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(onResize);
  mesurer();
  update();
})();

/* Menu du panneau — ouverture, fermeture, voile et clavier.

   Lot 127 : la bascule vivait dans `scoop.js` (un simple `hidden` inversé) et
   la fermeture ici. Deux fichiers pour un seul comportement, donc aucun
   endroit où poser le voile ni le focus. Tout le menu est désormais ici ;
   `scoop.js` n'y touche plus. `sbc-header.js` est chargé sur toutes les pages,
   sans condition (`layout/theme.liquid`), et avant `scoop.js`. */
(() => {
  const header = document.querySelector('[data-header]');
  const button = header?.querySelector('[data-menu-toggle]');
  const menu = header?.querySelector('[data-mobile-menu]');
  const voile = document.querySelector('[data-menu-voile]');
  if (!header || !button || !menu || menu.dataset.sbcMenu === 'true') return;

  menu.dataset.sbcMenu = 'true';

  const label = button.querySelector('.sr-only');
  const estOuvert = () => button.getAttribute('aria-expanded') === 'true';
  const sansMouvement = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const ouvrir = () => {
    button.setAttribute('aria-expanded', 'true');
    if (label) label.textContent = 'Fermer le menu';
    menu.hidden = false;
    document.documentElement.classList.add('sbc-menu-ouvert');
    if (voile) {
      voile.hidden = false;
      /* Une image d'attente, sinon l'élément passe de `display:none` à
         opaque sans jamais avoir été peint : pas de transition. Sans
         mouvement demandé, on saute l'attente et l'état est immédiat. */
      if (sansMouvement()) voile.classList.add('is-open');
      else requestAnimationFrame(() => voile.classList.add('is-open'));
    }
    /* Le focus entre dans le panneau, sur le panneau lui-même : son premier
       élément focusable est le champ de recherche, et lui donner le focus
       ferait monter le clavier virtuel par-dessus le menu que la cliente
       vient d'ouvrir. Le panneau porte `tabindex="-1"` ; la première
       tabulation atteint donc la recherche, sans clavier imposé. */
    menu.focus({ preventScroll: true });
  };

  const fermer = ({ rendreFocus = true } = {}) => {
    button.setAttribute('aria-expanded', 'false');
    if (label) label.textContent = 'Ouvrir le menu';
    menu.hidden = true;
    document.documentElement.classList.remove('sbc-menu-ouvert');
    if (voile) {
      voile.classList.remove('is-open');
      if (sansMouvement()) voile.hidden = true;
      else window.setTimeout(() => { if (!estOuvert()) voile.hidden = true; }, 220);
    }
    if (rendreFocus) button.focus();
  };

  button.addEventListener('click', () => (estOuvert() ? fermer() : ouvrir()));

  menu.addEventListener('click', (event) => {
    if (event.target.closest('a[href]')) fermer({ rendreFocus: false });
  });

  if (voile) voile.addEventListener('click', () => fermer());

  document.addEventListener('keydown', (event) => {
    if (!estOuvert()) return;

    if (event.key === 'Escape') {
      fermer();
      return;
    }

    if (event.key !== 'Tab') return;

    /* Le voile rend le menu modal : la tabulation doit tourner entre le
       bouton (qui est aussi la croix de fermeture) et le contenu du panneau,
       plutôt que de partir dans une page devenue inatteignable à la souris. */
    const focusables = [button, ...menu.querySelectorAll('a[href], button, input:not([type="hidden"]), select, textarea')]
      .filter((el) => el.offsetParent !== null || el === button);
    if (focusables.length === 0) return;
    const premier = focusables[0];
    const dernier = focusables[focusables.length - 1];
    const actif = document.activeElement;

    if (event.shiftKey && (actif === premier || actif === menu)) {
      event.preventDefault();
      dernier.focus();
    } else if (!event.shiftKey && actif === dernier) {
      event.preventDefault();
      premier.focus();
    }
  });
})();
